import {SortableElement} from 'react-sortable-hoc';

const SortableItem = SortableElement(({children}) => <li>{children}</li>);

export default SortableItem;